import { P02_01 } from "./P02_01"

export const P02 = {
    "columns": 12,
    "rows": 3,
    "visual": {
        "id": 13,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Product Sales Summary",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Product Code',
                        "columnName": 'ItemCode',
                        "width": '150px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Product Name',
                        "columnName": 'ItemName',
                        "width": '180px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Quantity Sold',
                        "columnName": 'QuantitySold',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Quantity Free',
                        "columnName": 'QuantityFree',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Total Quantity',
                        "columnName": 'TotalQuantity',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'YTD Quantity Sold',
                        "columnName": 'YTDQuantitySold',
                        "width": '200px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY YTD Quantity Sold',
                        "columnName": 'YTDLYQuantitySold',
                        "width": '200px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'QuantitySoldGrowth',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Net Sales',
                        "columnName": 'ActualSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY Net Sales',
                        "columnName": 'LYSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'YTD Net Sales',
                        "columnName": 'YTDActualSales',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY YTD Net Sales',
                        "columnName": 'YTDLYSales',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'YTDGrowth',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "ItemName",
                "endpoint": "P02",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" },
                    { "key": "DistributorCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": P02_01
                }
            }
        }
    }
}